var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "192px",
    height: "192px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.5 2 A 3 3 0 0 0 9.671875 6 L 1 6 L 1 17 L 12 17 L 12 7.9550781 A 3 3 0 0 0 12.5 8 A 3 3 0 0 0 12.5 2 z M 19 4 A 2 2 0 0 0 19 8 A 2 2 0 0 0 19 4 z M 4 9 L 6 9 L 7 9 L 9 9 L 9 10 L 7 10 L 7 14 L 6 14 L 6 10 L 4 10 L 4 9 z M 14 9 L 14 19 L 7.609375 19 C 8.519375 20.78 10.37 22 12.5 22 C 15.24 22 17.529453 20.040312 17.939453 17.320312 C 17.979453 17.050312 18 16.78 18 16.5 L 18 9 L 14 9 z M 20 9 L 20 10 L 20 16.5 L 20 18.851562 C 21.723 18.409562 23 16.863 23 15 L 23 9 L 20 9 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.15a3d34b38ebda9069092b5768a8f227.svg";
export { ForwardRef as ReactComponent };